import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { criarPrefeituraDs, inserirOuAtualizar } from "../../DataSources";
import apiAxios from "../../api-axios";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  clienteId: undefined,
  nome: "",
  prefeituraOrgao: "",
  logradouro: "",
  enderecoNumero: "",
  enderecoComplemento: "",
  bairro: "",
  cep: "",
  cnpj: "",
  lei: "",
  decreto: "",
  prefeituraLogo: "",
  prefeituraLogoNfse: "",
  prefeituraTopo: "",
  prefeituraTopoNfse: "",
  prefeituraBrasão: "",
  prefeituraBrasãoNfse: "",
  prefeituraSituacaoBool: true,
  prefeituraSituacao: "",
  estadoId: 23,
  nomeEstado: "Ceará",
  municipioId: undefined,
  prefeituraEnderecoTipo: "Nacional",
  prefeituraEnderecoPais: "Brasil",
  febraban: "",
  prefeituraInformacoesPagamento: "",
  diaVencimento: "",
};

export default class PrefeituraForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.municipioId = UserInfo.getMunicipioId();
    this.prefeituraDs = criarPrefeituraDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.prefeituraDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data === undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/prefeituras");
          }
          data.municipio = undefined;
          data.clienteId = data.id;
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="INFORMAÇÕES DA PREFEITURA"
              colSpan={2}
              colCount={2}
            >
              <SimpleItem dataField={"clienteId"} editorType={"dxNumberBox"} />
              <SimpleItem dataField={"nome"} />
              <SimpleItem dataField={"prefeituraOrgao"}>
                <Label text="Órgão" />
              </SimpleItem>
              <SimpleItem dataField={"cnpj"}>
                <Label text="CNPJ" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraLogo"}>
                <Label text="Logotipo" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraLogoNfsa"}>
                <Label text="Logotipo Nota Fiscal" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraTopo"}>
                <Label text="Topo" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraTopoNfse"}>
                <Label text="Topo Nfse" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraBrasao"}>
                <Label text="Brasão" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraBrasaoNfse"}>
                <Label text="Brasão Nfse" />
              </SimpleItem>
              <SimpleItem
                dataField={"prefeituraSituacaoBool"}
                editorType={"dxCheckBox"}
              >
                <Label text="Ativo" />
              </SimpleItem>
            </GroupItem>

            <GroupItem
              caption="INFORMAÇÕES DE ENDEREÇO"
              colSpan={2}
              colCount={2}
            >
              <SimpleItem dataField={"logradouro"}>
                <Label text="Logradouro" />
              </SimpleItem>
              <SimpleItem dataField={"enderecoNumero"}>
                <Label text="Nº" />
              </SimpleItem>
              <SimpleItem dataField={"enderecoComplemento"}>
                <Label text="Complemento" />
              </SimpleItem>
              <SimpleItem dataField={"bairro"}>
                <Label text="Bairro" />
              </SimpleItem>
              <SimpleItem dataField={"cep"}>
                <Label text="CEP" />
              </SimpleItem>
              <SimpleItem dataField={"nomeEstado"}>
                <Label text="Estado" />
              </SimpleItem>
              <SimpleItem dataField={"municipioId"}>
                <Label text="Município IBGE" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraEnderecoTipo"}>
                <Label text="Tipo de Endereço" />
              </SimpleItem>
              <SimpleItem dataField={"prefeituraEnderecoPais"}>
                <Label text="País" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="INFORMAÇÕES NFS-e" colSpan={1}>
              <SimpleItem dataField={"lei"}>
                <Label text="Lei" />
              </SimpleItem>
              <SimpleItem dataField={"decreto"}>
                <Label text="Decreto" />
              </SimpleItem>
              <SimpleItem dataField={"diaVencimento"}>
                <Label text="Dia de Vencimento" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Febraban">
              <SimpleItem dataField={"febraban"}>
                <Label text="Febraban" />
              </SimpleItem>
              <SimpleItem
                dataField={"prefeituraInformacoesPagamento"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "90px" }}
              >
                <Label text="Informações de pagamento" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <br />
          <br />
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    entidade.prefeituraSituacao = entidade.prefeituraSituacaoBool ? "A" : "I";
    inserirOuAtualizar(this.prefeituraDs, entidade)
      .then((response) => {
        console.log(response);
        notify("Prefeitura cadastrada com sucesso.", "success");
        this.props.history.goBack();
      })
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
